/* eslint-disable prettier/prettier */
import React from 'react'
import {Box,makeStyles,Typography} from '@material-ui/core'

const useStyles = makeStyles({
  container :{
    background:'#e8e8e8',
    cursor:'pointer',
    width:'100%',
    display:'flex',
    flexDirection:'column',
    padding:'10px',
    color:'black',
    '&:hover':{
      background:'#ffcd48',
      color:'white'
    },
   
  }
})

const UserListItem = ({user,handleFunction}) => {
 
 const classes = useStyles()
  return (
    <Box className={classes.container} onClick={handleFunction}>
      <Typography>{user.username}</Typography>
      <Typography style={{color:'grey'}}>{user.email}</Typography>
    </Box>
  )
}

export default UserListItem
